import $ from "jquery";
import { prettyScroll } from "../../helpers/dom";
export const scrollToURLFragment = () => {
    var _a, _b;
    const fragment = location.hash;
    if ((fragment === null || fragment === void 0 ? void 0 : fragment.length) > 1) {
        const $stickyNav = $("#js-sticky-nav");
        const $enhancedStickyNav = $("#js-enhanced-sticky-nav");
        const $helloBar = $(".c-hello-bar");
        const $header = $(".c-header");
        const $activeNav = $enhancedStickyNav.length ? $enhancedStickyNav : $stickyNav;
        const headerHeight = $header.outerHeight(true);
        const stickyNavHeight = $activeNav.outerHeight(true);
        const targetScrollTop = ((_b = (_a = $(fragment)) === null || _a === void 0 ? void 0 : _a.offset()) === null || _b === void 0 ? void 0 : _b.top) - stickyNavHeight;
        setTimeout(() => {
            window.scrollTo({ top: targetScrollTop, behavior: 'auto' });
        }, 25);
        setTimeout(() => {
            var _a, _b;
            const scrollTop = (_b = (_a = $(fragment)) === null || _a === void 0 ? void 0 : _a.offset()) === null || _b === void 0 ? void 0 : _b.top;
            let offsetTop = scrollTop - (headerHeight + stickyNavHeight);
            if ($helloBar.length && $helloBar.is(":visible")) {
                offsetTop -= $helloBar.outerHeight(true);
            }
            if (offsetTop < 0) {
                offsetTop = 0;
            }
            if (offsetTop) {
                prettyScroll(0, offsetTop);
            }
        }, 50);
    }
};
